export const GOOGLE_SSO_LOADING_LOCAL_STORAGE = 'googleSso';
export const GOOGLE_SSO_LOCAL_STORAGE_CHANGE = 'localStorageChangeGoogleSSO';
